import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import NumberFormat from 'react-number-format';

export default class ConfigTax extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            id_to_remove: null,
            loading: true
        }
    }
    toggle = () => this.setState({ modal: !this.state.modal });
    componentDidMount() {
        this.httpPost("api/v1/configtax/get", {
            id: 0
        }).then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }



    newitemRow(id) {
        for (var i = 0; i < this.state.data.record.length; i++) {
            if (this.state.data.record[i].id === id) {
                const maxValueOfY = Math.max.apply(Math, this.state.data.record[i].taxDetails.map(function (o) { return o.id; }))
          
                this.state.data.record[i].taxDetails.push({
                    id: maxValueOfY + 1,
                    taxHeaderId: id,
                    taxSalaryFloor: 0,
                    taxSalaryCeiling: 0,
                    taxGreatRate: 0
                });

            }
        }
        this.setState({ data: this.state.data });
    }

    confirmRemove(recordId) {
        for (var i = 0; i < this.state.data.record.length; i++) {
            if (this.state.data.record[i].id === recordId) {
                this.state.data.record.splice(i, 1);
            }
        }
        this.setState({ data: this.state.data });
    }
    Removerow(id, recordId) {
        for (var i = 0; i < this.state.data.record.length; i++) {
            if (this.state.data.record[i].id === recordId) {
                for (var j = 0; j < this.state.data.record[i].taxDetails.length; j++) {
                    if (this.state.data.record[i].taxDetails[j].id === id) {
                        this.state.data.record[i].taxDetails.splice(j, 1);
                    }
                }
            }
        }

        this.setState({ data: this.state.data });
    }
   


    setBodyValue(id, field, value, idheader, type) {
        if (type === 1) {
            for (var i = 0; i < this.state.data.record.length; i++) {
                if (this.state.data.record[i].id === id) {
                    this.state.data.record[i][field] = value;
                }

            }

        }
        else if (type === 2) {
            for (var i = 0; i < this.state.data.record.length; i++) {
                if (this.state.data.record[i].id === idheader) {
                    for (var j = 0; j < this.state.data.record[i].taxDetails.length; j++) {
                        if (this.state.data.record[i].taxDetails[j].id === id) {
                            this.state.data.record[i].taxDetails[j][field] = value;
                        }
                    }

                }
            }
        }
        this.setState({ data: this.state.data });
    }
    newBodyRow(e) {
        e.preventDefault();
        var detail = [];
        const maxValueOfY = Math.max(this.state.data.record.map(o => o.id), 0);
        detail.push({
            id: 1,
            taxHeaderId: maxValueOfY+1,
            taxSalaryFloor: 0,
            taxSalaryCeiling: 0,
            taxGreatRate: 0
        });
        this.state.data.record.push({
            id: maxValueOfY+1,
            taxTitle: null,
            taxType: null,
            taxDetails: detail

        });

        this.setState({ data: this.state.data });
    }


    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/configtax/save", {
            record: this.state.data.record



        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        data: data,
                        loading: false, modal: !this.state.modal
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getQuestion() {
        return [
            <div className="modal fade" tabindex="-1" id="modalConfirmRemove2" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                <h4 className="nk-modal-title">هشدار حذف اطلاعات</h4>
                                <div className="nk-modal-text">
                                    <p className="lead">آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                                    <p className="text-soft">توجه داشته باشید که در صورت حذف اطلاعات دیگر امکان بازیابی اطلاعات وجود ندارد</p>
                                </div>
                                <div className="nk-modal-action mt-5">
                                    <a className="btn btn-lg btn-mw btn-danger hand" data-bs-dismiss="modal" onClick={e => { this.removeAccount(); }} style={{ "margin-left": "25px" }}>بله - حذف شود</a>
                                    <a className="btn btn-lg btn-mw btn-light hand" data-bs-dismiss="modal" onClick={e => { this.setState({ id_to_remove: null }); }}>خیر - برگشت</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
    renderForm() {
        return <div className="container-fluid">
            <div className="nk-content-inner">
                <div className="nk-content-body">
                    <div className="components-preview wide-md mx-auto">
                        <div className="nk-block-head nk-block-head-lg wide-sm">
                            <div className="nk-block-head-content">
                                <div className="nk-block-head-sub">
                                    <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <form method="post" onSubmit={e => this.save(e)} novalidate="novalidate">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-aside-wrap">
                                        <div className="card-inner card-inner-lg">
                                            <div className="nk-block-head nk-block-head-lg">
                                                <div className="nk-block-between">
                                                    <div className="nk-block-head-content">
                                                        <span>این تنظیمات به شما کمک می کند تنظیمات مالیات شرکت را تغییر دهید.</span>
                                                        <button className="btn btn-outline-success" type="button" onClick={e => this.newBodyRow(e)}>جدول مالیاتی جدید</button>
                                                    </div>

                                                    <div className="nk-block-head-content align-self-start d-lg-none">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="nk-block">
                                                <div class="card-inner-group">
                                                    {this.state.data.record.map((record, index) =>
                                                        <div class="card-inner border border-gray bg-lighter text-dark">
                                                            <div class="nk-block-text bg-gray-600 text-white">

                                                                <button className="btn-round btn " onClick={e => this.confirmRemove(record.id)} >
                                                                    <em class="icon ni ni-cross-round-fill text-white"></em>
                                                                </button>
                                                            </div>
                                                            <br />
                                                            <div className="row">
                                                                <input className="form-control text-center ltr" type="text" value={record.taxTitle} onChange={e => this.setBodyValue(record.id, 'taxTitle', e.target.value, record.id, 1)} />

                                                            </div>
                                                            <br />
                                                            {record.taxDetails.map((item, indexs) =>
                                                                <div class="between-center flex-wrap g-3 border">
                                                                    <div class="nk-block-text">

                                                                        <button className="btn-round btn" onClick={e => this.Removerow(item.id, record.id)}>
                                                                            <em class="icon ni ni-cross-round-fill"></em>
                                                                        </button>
                                                                    </div>


                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">کف حقوق ماهیانه</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" value={item.taxSalaryFloor} onChange={e => this.setBodyValue(item.id, 'taxSalaryFloor', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))), record.id, 2)} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">سقف حقوق ماهیانه</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" value={item.taxSalaryCeiling} onChange={e => this.setBodyValue(item.id, 'taxSalaryCeiling', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))), record.id, 2)} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">نرخ فوق العاده</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" value={item.taxGreatRate} onChange={e => this.setBodyValue(item.id, 'taxGreatRate', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))), record.id, 2)} />


                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                </div>

                                                            )}
                                                            <br />
                                                            <br />
                                                            <div className="nk-block-head-content">
                                                                <button className="btn btn-outline-success btn-sm" type="button" onClick={e => this.newitemRow(record.id)}>ردیف مالیات جدید</button>
                                                            </div>




                                                        </div>

                                                    )}
                                                        <br />
                                                        <button className="btn btn-outline-success" type="submit" onClick={e => this.save(e)}>ثبت نهایی جداول مالیات</button>

                                                </div>
                                            </div>

                                        </div>

                                            <div class="card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg toggle-screen-lg" data-toggle-body="true" data-content="userAside" data-toggle-screen="lg" data-toggle-overlay="true" style={{ backgroundColor: "#16498a" }}>
                                                <div class="card-inner-group" data-simplebar="init">
                                                    <div class="simplebar-wrapper" style={{ margin: '0px' }} >
                                                        <div class="simplebar-height-auto-observer-wrapper">
                                                            <div class="simplebar-height-auto-observer"></div>
                                                        </div>
                                                        <div class="simplebar-mask">
                                                            <div class="simplebar-offset" style={{ left: '0px', bottom: '0px' }} >
                                                                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{ height: 'auto', overflow: 'hidden' }} >
                                                                    <div class="simplebar-content" style={{ padding: '0px' }} >
                                                                        <div class="card-inner">
                                                                            <h3 class="nk-block-title page-title text-white">تنظیمات</h3>
                                                                            <div class="nk-block-des text-soft text-white">
                                                                                <p className="text-white">در این قسمت مزایای شرکت خود را تعریف میکنید</p>
                                                                            </div>
                                                                        </div>

                                                                        <div class="card-inner p-0">
                                                                            <ul class="link-list-menu">
                                                                                <li>
                                                                                    <a class="active" className="text-white" href="/ConfigCompany"><em class="icon ni ni-user-fill-c text-white"></em><span>مزایا</span></a>
                                                                                </li>
                                                                                <li style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)", backgroundColor: "#fff" }}>
                                                                                    <a href="/ConfigTax" style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)" }} ><em class="icon ni ni-lock-alt-fill"></em><span>جدول مالیات</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/FixedAmount" className="text-white"><em class="icon ni ni-shield-star-fill text-white"></em><span>مبلغ ثابت جهت قرارداد</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/InsuranceTaxSettings" className="text-white"><em class="icon ni ni-activity-round-fill text-white"></em><span>سایر تنظیمات بیمه و مالیات</span></a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="simplebar-placeholder" style={{ width: 'auto', height: '376px' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ width: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-vertical" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ height: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                    </div>
                                </div>
                                </div>
                            </form>
                        </div>



                    </div>
                </div>
            </div>





        </div >

    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getQuestion(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}